import styled from "styled-components";
import {
  borderRadius,
  borderWidth,
} from "../../../design-system/tokens/borders";
import { spacing } from "../../../design-system/tokens/spacing";
import { shadows } from "../../../design-system/tokens/shadows";
import { typographyMixin } from "../../../design-system/tokens/typography";

const sectionExpandEasing = "cubic-bezier(0.4, 0, 0.2, 1)";
const sectionExpandDuration = "0.35s";

export const SectionCard = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: ${spacing[2]} ${spacing[3]} ${spacing[3]};
  background: ${({ theme }) => theme.colors.surface.primary};
  border: ${borderWidth[1]} solid ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius.lg};
  box-shadow: ${shadows.component.card.sectionHeader};
`;

/** CSS grid 0fr/1fr collapse — keeps tiles mounted for a smooth open/close. */
export const CollapsibleBody = styled.div<{ $isOpen: boolean }>`
  display: grid;
  grid-template-rows: ${({ $isOpen }) => ($isOpen ? "1fr" : "0fr")};
  transition: grid-template-rows ${sectionExpandDuration} ${sectionExpandEasing};
`;

export const CollapsibleInner = styled.div<{ $isOpen: boolean }>`
  overflow: hidden;
  min-height: 0;
  padding-top: ${({ $isOpen }) => ($isOpen ? spacing[4] : "0")};
  transition: padding-top ${sectionExpandDuration} ${sectionExpandEasing};
`;

export const CardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing[4]};
  padding: 0 ${spacing[5]};
`;

export const EmptyNote = styled.p`
  margin: 0;
  padding: 0 ${spacing[5]} ${spacing[2]};
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.tertiary};
`;
